import { Injectable, Injector } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'vnpost-shared';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WeightConfigurationService extends BaseService {
  constructor(http: HttpClient, injector: Injector) {
    super(http, injector, `${environment.apiDomain.llbJavaEndpoint}/weightConfiguration`);
  }
  getAll(model: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/getAll`;
    return this._http
      .post<any>(apiUrl, model)
      .toPromise();
  }
  create(model: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/create`;
    return this._http
      .post<any>(apiUrl, model)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  update(id: any, model: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/update/${id}`;
    return this._http
      .put<any>(apiUrl, model)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  delete(id: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/inActive/${id}`;
    return this._http
      .put<any>(apiUrl, {})
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  getWeightConfiguration(id: any) {
    const apiUrl = `${this.serviceUri}/detail/${id}`;
    return this._http
      .get<any>(apiUrl)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
}